import jwt_decode from 'jwt-decode';
import { UserData } from '../../user-admin/models/user-data.model';

export enum UserRole {
  GroupAdmin = 'group-admin',
  WdlAdmin = 'wdl-admin',
  WdlModerator = 'wdl-moderator',
  Exporter = 'exporter',
}

export class User {
  public token: string;
  public roles: UserRole[] = [];
  public data?: UserData;

  constructor(token: string, data?: UserData) {
    this.token = token;
    this.data = data;
    if (token) {
      try {
        const jwt: any = jwt_decode(token);
        this.roles = jwt['cognito:groups'];
      } catch (error) {
        console.error(error);
      }
    }
  }

  public toString() {
    return JSON.stringify({
      token: this.token,
      roles: this.roles,
      data: this.data,
    });
  }
}

export type userRoles =
  | {
      export: boolean;
    }
  | undefined;

export class UserFreemium {
  constructor(
    public email: string,
    public firstName: string,
    public lastName: string,
    public organizationName: string,
    public contactMe: boolean,
    public categoryCoicopCode: string,
    public phoneNumber: string
  ) {}
}
